import Vue from 'vue'
import Vuex from 'vuex'
import * as MUTATION from './const.mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoaded: false,
    scrollTop: 0,
    mousePosition: {x: 0, y: 0},
    user: null,
    quiz: {
      screening: {},
      qualiscore: {}
    },
    quizIndex: { survey: 'screening', index: 1 },
    userResponses: []
  },
  mutations: {
    [MUTATION.SET_USER] (state, user) {
      state.user = user
    },
    [MUTATION.SET_MOUSE_POSITION] (state, value) {
      state.mousePosition = value
    },
    [MUTATION.SET_SCROLL_TOP] (state, value) {
      state.scrollTop = value
    },
    [MUTATION.SET_QUIZ] (state, quiz) {
      state.quiz = quiz
    },
    [MUTATION.SET_QUIZ_INDEX] (state, index) {
      state.quizIndex = index
    },
    [MUTATION.SET_QUALISCORE] (state, value) {
      state.user.qualiscore = value
    },
    [MUTATION.SET_USER_RESPONSES] (state, value) {
      state.userResponses.push(value) 
    },
    [MUTATION.RESET_USER_RESPONSES] (state) {
      state.userResponses = []
    },
    [MUTATION.SET_IS_LOADED] (state, value) {
      state.isLoaded = value
    }
  },
  actions: {
    setIsLoaded({ state, commit }, value) {
      commit(MUTATION.SET_IS_LOADED, value)
    },
    setMousePosition ({ state, commit }, value) {
      commit(MUTATION.SET_MOUSE_POSITION, value)
    },
    setScrollTop({ state, commit }, value) {
      commit(MUTATION.SET_SCROLL_TOP, value)
    },
    setUser({ state, commit }, user) {
      commit(MUTATION.SET_USER, user)
    },
    setQuiz({ state, commit }, quiz) {
      commit(MUTATION.SET_QUIZ, quiz)
    },
    setQuizIndex({ state, commit }, index) {
      commit(MUTATION.SET_QUIZ_INDEX, index)
    },
    setQualiscore({ state, commit }, value) {
      commit(MUTATION.SET_QUALISCORE, value)
    },
    setUserResponses({ state, commit }, value) {
      commit(MUTATION.SET_USER_RESPONSES, value)
    },
    resetUserResponses({ state, commit }) {
      commit(MUTATION.RESET_USER_RESPONSES)
    }
  },
  getters: {
    getIsLoaded(state)
    {
      return state.isLoaded
    },
    getMousePosition (state) {
      return state.mousePosition
    },
    getScrollTop (state) {
      return state.scrollTop
    },
    getUser (state) {
      return state.user
    },
    getQuiz (state) {
      return state.quiz
    },
    getQuizIndex (state) {
      return state.quizIndex
    },
    getUserResponses (state) {
      return state.userResponses
    }
  }
})
